import { Skeleton, Stack } from '@mui/material';

export default function SkeletonForm() {
  return (
    <Stack sx={{ gap: 3 }}>
      <Skeleton variant="rounded" width="100%" height={64} />
      <Stack sx={{ gap: 2, width: '100%' }}>
        <Stack sx={{ width: '100%' }}>
          <Skeleton variant="text" width="100%" height={16 * 2} />
          <Skeleton variant="rounded" width="100%" height={36} />
        </Stack>
        <Stack sx={{ width: '100%' }}>
          <Skeleton variant="text" width="100%" height={16 * 2} />
          <Skeleton variant="rounded" width="100%" height={36} />
        </Stack>
        <Stack sx={{ width: '100%' }}>
          <Skeleton variant="text" width="100%" height={16 * 2} />
          <Skeleton variant="rounded" width="100%" height={36} />
          <Skeleton variant="text" width="100%" height={16 * 3} />
        </Stack>
      </Stack>
      <Skeleton variant="rounded" width="100%" height={64} />
    </Stack>
  );
}
